/**
 * Header search form.
 * 
 * @since 1.0.0
 * @author Fahri Rusliyadi <fahri.rusliyadi@gmail.com>
 */

'use strict';

import $ from 'jquery';

export default function() {
    $(document).on('submit', '#header-search .searchform', function() {
        // Trigger blur to hide the Algolia autocomplete results.
        $(this).find(':focus').trigger('blur');
    });
};